import { Heading2 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import {
  color,
  container,
  fontFamily,
  fontSize,
  fontWeight,
  radius,
  screen,
  spacing
} from 'theme';

export const StyledWrapper = styled.div`
  max-width: ${container('xl')};
  margin: ${spacing('xl2')} auto;
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};

  ${Heading2} {
    text-align: center;
  }
`;

export const StyledTotal = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: ${spacing('mdlg')};
  margin-top: ${spacing('lg')};
  margin-bottom: ${spacing('xl2')};

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
    gap: ${spacing('lg')};
  }
`;

export const StyledTotalTitle = styled.h3`
  margin: 0;
  font-family: ${fontFamily('display')};
  font-size: ${fontSize('xl5')};
  font-weight: ${fontWeight('light')};
  text-transform: uppercase;
  color: ${color('text_subtle')};
`;

export const StyledTotalData = styled.div`
  display: flex;
  gap: ${spacing('mdlg')};
`;

export const StyledTotalDataItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('xs2')};
`;

export const StyledTotalDataItemTitle = styled.span`
  color: ${color('text_subtle')};
  font-weight: ${fontWeight('medium')};
  line-height: 1.25;
`;

export const StyledTotalDataItemValue = styled.span`
  font-size: ${fontSize('lg')};
  font-weight: ${fontWeight('extraBold')};
  line-height: 1.2;
`;

export const StyledLegend = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${spacing('xl2')};
  margin-bottom: ${spacing('md')};
  max-width: ${container('md')};

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
  }

  > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${spacing('sm')};

    @media (min-width: ${screen('md')}) {
      width: 50%;
    }
  }

  p {
    margin: 0;
    font-size: ${fontSize('xs')};
    line-height: 1.333;
    color: ${color('text_subtle')};
  }
`;

export const StyledLegendTitle = styled.div`
  display: flex;
  justify-content: center;
  gap: ${spacing('sm')};
  font-size: ${fontSize('xs')};
  line-height: 1.333;
  font-weight: ${fontWeight('medium')};

  > div {
    width: ${spacing('md')};
    height: ${spacing('md')};
    border-radius: ${radius('sm')};

    &.sales {
      background-color: ${color('set3_01')};
    }
    &.turnover {
      background-color: ${color('set3_07')};
    }
  }
`;

export const StyledChart = styled.div`
  overflow-y: hidden;
  overflow-x: hidden;

  @media (max-width: ${screen('mdMax')}) {
    overflow-x: auto;
  }

  .recharts-surface {
    max-height: 100%;
    margin-top: 3px;
  }

  .recharts-cartesian-axis-line {
    stroke: ${color('midnight_200')};
  }

  .recharts-text {
    fill: ${color('text_default')};
    font-size: ${fontSize('sm')};
    text-transform: uppercase;
    font-weight: ${fontWeight('medium')};
  }

  .recharts-label {
    text-transform: inherit;
    fill: ${color('text_subtle')};
  }

  .recharts-legend-wrapper {
    right: -${spacing('lg')} !important;
  }

  .recharts-legend-item {
    margin-bottom: ${spacing('xs')};
    display: flex !important;
    align-items: center;
  }

  .recharts-legend-item-text {
    color: ${color('text_default')} !important;
    font-size: ${fontSize('sm')};
    text-align: left;
  }

  .recharts-default-tooltip {
    background-color: ${color('midnight_800')} !important;
    border: 0 !important;
    border-radius: ${radius('sm')};
    padding: ${spacing('sm')} !important;
    font-size: ${fontSize('sm')};
    color: ${color('text_white')};
    font-weight: ${fontWeight('medium')};
    position: relative;

    &::before {
      content: '';
      width: 0;
      height: 0;
      position: absolute;
    }
  }

  .recharts-tooltip-wrapper-bottom .recharts-default-tooltip.tooltip-y::before {
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid ${color('midnight_800')};
    top: -5px;
    left: 50%;
    right: unset;
    transform: translateX(-50%);
  }

  .recharts-tooltip-wrapper-top .recharts-default-tooltip.tooltip-y::before {
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid ${color('midnight_800')};
    bottom: -5px;
    left: 50%;
    right: unset;
    transform: translateX(-50%);
  }

  .recharts-tooltip-wrapper-left .recharts-default-tooltip.tooltip-x::before {
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid ${color('midnight_800')};
    right: -5px;
    left: unset;
    top: 50%;
    transform: translateY(-50%);
  }

  .recharts-tooltip-wrapper-right .recharts-default-tooltip.tooltip-x::before {
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid ${color('midnight_800')};
    left: -5px;
    top: 50%;
    transform: translateY(-50%);
  }

  .recharts-tooltip-item {
    padding: 0 !important;
    color: inherit !important;
  }

  .recharts-tooltip-item-name {
    font-weight: ${fontWeight('extraBold')};
  }
`;
